// extracted by mini-css-extract-plugin
module.exports = {"button":"GradeComponent-module--button--1PoyM","large":"GradeComponent-module--large--2IFPF","active":"GradeComponent-module--active--1ZIP1"};